import axios from 'axios'
import api from "@/config/api"

const functions = {
    /**
     * ajax请求
     */
    ajax (method, url, data) {
        const config = {
            method: method,
            baseURL: api.baseUrl,
            url: url,
            validateStatus: () => {
                return true
            }
        }
        if (data) {
            switch (method) {
                case 'get':
                    config.params = data
                    break
                default:
                    config.data = data
            }
        }
        return axios(config).catch(error => {
            return Promise.reject(error)
        }).then(({ data }) => {
            return Promise.resolve(data)
        })
    },
    /**
     * get请求
     */
    get (url, json, successCallback) {
        return this.ajax('get', url, json, successCallback)
    },
    /**
     * post请求
     */
    post (url, json, successCallback) {
        return this.ajax('post', url, json, successCallback)
    },
    /**
     * delete请求
     */
    delete (url, json = {}, successCallback) {
        return this.ajax('delete', url, json, successCallback)
    },
    /**
     * patch请求
     */
    patch (url, json = {}, successCallback) {
        return this.ajax('patch', url, json, successCallback)
    },
    /**
     * put
     */
    put (url, json = {}, successCallback) {
        return this.ajax('put', url, json, successCallback)
    },
    /**
     * 请求拦截器
     */
    setRequestInterceptor () {
        axios.interceptors.request.use(config => {
            config.headers['Content-Type'] = 'application/json;charset=utf-8'
            const token = localStorage.getItem('token')
            if (token) {
                config.headers['Access-Token'] = token
            }
            return config
        }, (error) => {
            return error
        })
    },
    /**
     * 响应拦截器
     */
    setResponseInterceptor() {
        const vue = this.vue

        axios.interceptors.response.use(response => {
            const routeName = this.vue.$route.name

            if (!response) {
                return vue.$message.error('请求失败')
            }

            if (response.status !== 200) {
                const message = response.data.message || `服务器开小差啦 [${response.status}]`
                vue.$message.destroy()
                vue.$message.error(message)
                return Promise.reject(response)
            }

            if (response.data.code === 403) {
                vue.$message.destroy()
                vue.$message.error('没有操作权限')
                return Promise.reject(response)
            }

            if (response.data.code === 401) {
                vue.$message.destroy()
                vue.$message.error('登录信息已失效或未授权')
                vue.$store.commit("resetOpenTab");
                localStorage.removeItem('token')

                if (routeName !== 'login') {
                    this.vue.$router.push({
                        name: 'login',
                        params: {
                            'platform': localStorage.getItem('platform')
                        }
                    })
                }

                return Promise.reject(response);
            }

            if (response.data.code !== 0) {
                vue.$message.destroy()
                vue.$message.error(response.data.message || response.status)
                return Promise.reject(response)
            }

            let token = response.headers['access-token']

            if (token) {
                localStorage.setItem('token', token)
            }

            return response
        }, error => {
            vue.$message.destroy()
            vue.$message.error(error.message || '请求失败')
            return Promise.reject(error)
        })
    }
}

export default functions
